import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const CONTACT = {
  phone: "0400 229 777",
  phoneDial: "tel:0400229777",
  email: "peerwave.club@proton.me",
  emailLink: "mailto:peerwave.club@proton.me",
  location: "Fraser Coast, Queensland",
  facebook: "https://www.facebook.com/peer.wave",
  facebookLabel: "@peer.wave",
};
